module.exports = __webpack_public_path__ + "img/fiscal.5d10bf01.jpg";